export const UuidHelper = {
	/**
	 * Generate a random string with the specified length.
	 */
	generateUUID(length = 22, radix?: number): string {
		const BASE64URICHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('');
		radix = radix || BASE64URICHARS.length;
		const newId = [];
		for (let i = 0; i < length; i++) {
			newId[i] = BASE64URICHARS[0 | (Math.random() * radix)];
		}
		return newId.join('');
	},
};
